const billStatus = {
  A: '创建',
  B: '审核中',
  C: '已审核',
  D: '重新审核',
  E: '已生成凭证'
}

const docStatus = {
  A: '创建',
  B: '审核中',
  C: '已审核',
  D: '重新审核',
  E: '已生成凭证'
}

const action = {
  ADD: 'add',                       // 新增
  SAVE: 'save',                     // 保存
  EDIT: 'edit',                     // 修改
  STARTEDIT: 'startEdit',           // 开始修改
  SUBMIT: 'submit',                 // 提交
  UNSUBMIT: 'unSubmit',             // 撤销
  AUDIT: 'audit',                   // 审核
  UNAUDIT: 'unAudit',               // 反审核
  EXIT: 'exit',                     // 退出
  APPROVAL: 'approval',             // 审批
  REJECT: 'reject',                 // 驳回
  MORE: 'more',                     // 更多查询
  REFRESH: 'refresh',               // 刷新
  DELETE: 'delete',                 // 删除
  DISABLE: 'disable',               // 禁用
  ENABLE: 'enable',                 // 启用
  RELEASE: 'release',               // 投放
}

export default {
  billStatus,
  docStatus, // 单据类型
  action
}
